<!--自动回复设置-->
<template>
    <div>
        <el-form :model="form" :rules="formRules" ref="formRef" label-width="80px">
            <el-form-item label="自动回复" >
                <el-select v-model="form.autoFlag" clearable  style="width: 100%;">
                    <el-option v-for="item in autoFlags"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="回复内容" v-if="form.autoFlag">
                <el-input placeholder="请输入回复内容" v-model="form.content" clearable ></el-input>
            </el-form-item>
            <el-row>
                <el-col :span="1" :offset="7">
                    <el-form-item>
                        <el-button type="primary" @click="autoFlagSet" >提交</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

    </div>
</template>

<script>
import {replyconfigGet,replySet} from '@/api/replyConfig'
export default {
    name: "",
    props:{
        type:{
            type: String,
            default:''
        }
    },
    data() {
        return {
            form:{
                autoFlag:false,
                content:'',
                id:null
            },
            autoFlags:[
                {value: true,label:'是'},
                {value: false,label:'否'}
            ],
            formRules: {
                content: [
                    {required: true, message: '请输入回复内容', trigger: 'blur'}
                ],
            }
        }
    },
    methods:{
        init(){
            replyconfigGet(this.type).then(response => {
                if (response.code != 200) return this.$message.error('获取自动回复记录' + response.msg)
                this.form=response.data
                console.log('获取到自动设置',this.form,this.type)
            })
        },
        autoFlagSet(){
            /*220721 因为接口更改，将下面2个合并为一个
            if(this.type==='work_order'){
                workReplySet(this.form).then(response => {
                    if (response.code != 200) return this.$message.error('工单自动回复设置' + response.msg)
                    this.$message.success(response.msg)
                    this.$refs.formRef.resetFields()
                    this.$emit('closeEvent')
                })
            }else if(this.type==='repair_order'){
                repairReplySet(this.form).then(response => {
                    if (response.code != 200) return this.$message.error('维修单自动回复设置' + response.msg)
                    this.$message.success(response.msg)
                    this.$refs.formRef.resetFields()
                    this.$emit('closeEvent')
                })
            }*/
            replySet(this.form).then(response => {
                if (response.code != 200) return this.$message.error('自动回复设置' + response.msg)
                this.$message.success(response.msg)
                this.$refs.formRef.resetFields()
                this.$emit('closeEvent')
            })
        }
    },
    created(){
        this.init()
    }
}
</script>

<style scoped>

</style>
